import React from 'react';
import { History, Info } from 'lucide-react';
import { SizeSpacingPanel, ColorsFontsPanel } from '../common/BlockStyleSettings';
import { BLOCK_FEATURES } from '../common/commonDefaults';

const InitiativeTimelineEditor = ({ block, onChange, theme, hideStylePanels }) => {
  const { content } = block;

  const handleChange = (field, value) => {
    onChange({ [field]: value });
  };

  const handleStyleChange = (styleUpdates) => {
    onChange({ style: { ...(content.style || {}), ...styleUpdates } });
  };

  return (
    <div className="space-y-4">
      {/* Heading */}
      <div>
        <label className="block text-xs font-medium text-gray-400 mb-1">Section Heading</label>
        <input
          type="text"
          value={content.heading || ''}
          onChange={(e) => handleChange('heading', e.target.value)}
          className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#749555]"
          placeholder="Initiatives"
        />
      </div>

      {/* Info card */}
      <div className="flex items-start gap-2.5 p-3 bg-blue-500/10 border border-blue-500/20 rounded-lg">
        <Info size={14} className="text-blue-400 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-300 leading-relaxed">
          <span className="font-medium">Custom block.</span> Timeline data is managed externally via Firestore.
          Items are stored in the <code className="text-blue-200 bg-blue-500/10 px-1 rounded">customBlockData</code> collection.
        </div>
      </div>

      {/* Block icon badge */}
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <History size={12} />
        <span>Initiative Timeline (Premium Custom Block)</span>
      </div>

      {/* Style panels */}
      {!hideStylePanels && (
        <>
          <SizeSpacingPanel
            style={content.style || {}}
            onChange={handleStyleChange}
            features={BLOCK_FEATURES['initiative-timeline'] || ['heading', 'colors', 'spacing']}
          />
          <ColorsFontsPanel
            style={content.style || {}}
            onChange={handleStyleChange}
            features={BLOCK_FEATURES['initiative-timeline'] || ['heading', 'colors', 'spacing']}
            theme={theme || {}}
            blockType="initiative-timeline"
          />
        </>
      )}
    </div>
  );
};

export default InitiativeTimelineEditor;
